import { render, staticRenderFns } from "./StudentsResponsesModalCustom.vue?vue&type=template&id=4a642108&scoped=true&"
import script from "./StudentsResponsesModalCustom.vue?vue&type=script&lang=js&"
export * from "./StudentsResponsesModalCustom.vue?vue&type=script&lang=js&"
import style0 from "./StudentsResponsesModalCustom.vue?vue&type=style&index=0&id=4a642108&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a642108",
  null
  
)

export default component.exports